var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "startPageNotifications",
      staticClass: "start-page-notifications ci-card",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "start-page-notifications-header pt-3 pt-md-4 px-3 px-md-4 pb-3",
        },
        [
          _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
            _c("div", { staticClass: "flex-column flex-grow-1" }, [
              _c("h2", {
                staticClass: "h2",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.components.start.notifications.title")
                  ),
                },
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-muted",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.components.start.notifications.description")
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-xl-none" },
              [
                _c(_setup.CiButton, {
                  staticClass: "w-100",
                  attrs: {
                    variant: "filled-primary",
                    label: _vm.$t("ui.components.start.notifications.button"),
                    to: { name: _vm.$routes.NOTIFICATIONS_INDEX },
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _setup.emit("tracking-click", {
                        targetName: "ButtonAllNotifications",
                        sourceName: "Notifications",
                      })
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.Scrollable,
        {
          ref: "startPageNotificationsContainer",
          staticClass: "start-page-notifications-container",
          attrs: { "with-shadows": true },
        },
        [
          _c(_setup.NotificationsList, {
            attrs: {
              items: _setup.list,
              loading: _setup.loading,
              "handheld-style": true,
              type: "all",
              location: "popup",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "start-page-notifications-footer p-3 p-md-4" }, [
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _setup.list.length
              ? _c(_setup.CiButton, {
                  staticClass: "bottom-cta",
                  attrs: {
                    variant: "filled-primary",
                    label: _vm.$t("ui.components.start.notifications.button"),
                    to: { name: _vm.$routes.NOTIFICATIONS_INDEX },
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _setup.emit("tracking-click", {
                        targetName: "ButtonAllNotifications",
                        sourceName: "Notifications",
                      })
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }